import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLookupStore } from '../../context/useStore.js';
import { Page, Spinner, Box, InlineStack, Text } from '@shopify/polaris';

export default function InventoryRedirect() {
  const navigate = useNavigate();
  const { pickingplaces } = useLookupStore();

  useEffect(() => {
    // Redirect to the first available stockplaats
    if (pickingplaces && pickingplaces.length > 0) {
      navigate(`/inventory/${pickingplaces[0].counter}`, { replace: true });
    }
  }, [pickingplaces, navigate]);

  return (
    <Page title="Inventory">
      <Box padding="400">
        <InlineStack align="center" gap="200">
          <Spinner size="small" />
          <Text>Loading inventory locations...</Text>
        </InlineStack>
      </Box>
    </Page>
  );
}
